import { Config } from "common/config";
import { useResolution } from "common/hooks";
import { EColors } from "common/styles";
import { Styled } from "components/Styled";
import { Fade } from "react-awesome-reveal";
import { Component } from "./components";

import { ImageMap, StyledImageWrapper, StyledSectionFindUs } from "./styled";

export const FindUs = () => {
  const { isMinScreen455 } = useResolution();
  return (
    <StyledSectionFindUs color={EColors.bg_dark} id={Config.Section.findUs}>
      <Styled.Container>
        <Fade
          cascade
          triggerOnce
          direction="up"
          delay={800}
          duration={500}
          damping={0.5}
        >
          <Styled.H2 color={EColors.white}>Де нас знайти</Styled.H2>
          <Component.AddressList />
          <StyledImageWrapper>
            <Component.MapContainer />
            {/* <ImageMap
            src={isMinScreen455 ? `${Png.Map}` : `${Png.MapMob}`}
            alt="map"
          /> */}
          </StyledImageWrapper>
        </Fade>
      </Styled.Container>
    </StyledSectionFindUs>
  );
};
